import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import PieChartVideo from '../../../assets/videos/pie_chart_animated.mp4'

import * as styles from './CommencementSection.module.scss'
import { RegionContext } from '../../../context/region-context'
import Container from '../../container/Container'
import StoresBlock from '../../storesBlock/StoresBlock'
import StoresBlockDesktop from '../../storesBlock/StoresBlockDesktop'

function CommencementSection({ SMSF, horizontal }) {
  const region = useContext(RegionContext)

  const stepOneAppendItems = !horizontal && (
    <>
      <StoresBlockDesktop
        width="auto"
        height={56}
        className={styles.storesBlock}
      />
      <StoresBlock width="auto" height={56} className={styles.storesBlock} />
    </>
  )
  const COMMENCEMENT_STEPS = [
    {
      subtitle: '01',
      image: (
        <StaticImage
          className={styles.image}
          src="../../../assets/images/Steps_01.png"
          width="445"
          height="445"
          alt="Download our app"
        />
      ),
      heading: 'Download our app',
      text: 'Provide your personal information to verify your identity then you can securely link your bank account.',
      SMSF_text:
        'Enter your personal information including phone number, email, and password then click on the SMSF sign up option.',
      appendItems: stepOneAppendItems,
    },
    {
      subtitle: '02',
      className: styles.step2,
      image: (
        <video
          src={PieChartVideo}
          autoPlay
          loop
          muted
          playsInline
          className={styles.videoAll}
          width={445}
          height={445}
        />
      ),
      heading: 'Pick your portfolio mix',
      text: 'Select your preferred cryptocurrencies and precious metals then choose when to invest in them.',
      SMSF_text:
        'Enter your SMSF trustee name and fund name, followed by the bank account details attached to the fund.',
    },
    {
      subtitle: '03',
      image: (
        <StaticImage
          className={styles.image}
          src="../../../assets/images/Steps_03.png"
          width="445"
          height="445"
          alt="Start investing"
        />
      ),
      heading: 'Start investing',
      text: `That's it! We'll get you started in 90 seconds so you can begin your effortless crypto investing.`,
    },
  ]

  return (
    <section className={styles.commencementSection}>
      <Container>
        <div>
          <h1 className={styles.title}>How bamboo works</h1>
        </div>
        <section className={styles.stepsSection}>
          <h2 className="visually-hidden">Bamboo App starting steps</h2>
          <div className={classNames('steps', horizontal && styles.horizontal)}>
            {COMMENCEMENT_STEPS.map(
              (
                {
                  subtitle,
                  heading,
                  text,
                  SMSF_text,
                  className,
                  image,
                  appendItems,
                },
                index
              ) => (
                <div
                  className={classNames(styles.step, className)}
                  key={`${subtitle}_${index}`}
                >
                  {!horizontal && image}
                  <article className={styles.stepBlock}>
                    <div className={styles.stepSubtitle}>{subtitle}</div>
                    <h3 className={styles.stepHeading}>{heading}</h3>
                    <p className={styles.stepText}>
                      {SMSF ? SMSF_text || text : text}
                    </p>
                    {appendItems}
                  </article>
                </div>
              )
            )}
          </div>
        </section>
        <div className={styles.horizontalStores}>
          {horizontal && (
            <>
              <StoresBlockDesktop
                width="auto"
                height={56}
                className={styles.storesBlock}
              />
              <StoresBlock
                width="auto"
                height={56}
                className={styles.storesBlock}
              />
            </>
          )}
        </div>
      </Container>
    </section>
  )
}

CommencementSection.propTypes = {
  SMSF: PropTypes.bool,
}

export default CommencementSection
